<template>
    <div>
        <data-grid
            url="sms?broadcastID="
            :columns="columns"
            :title="title"
            :actions="actions"
            :mapper="mapResults"
            :sortOptions="{
                enabled: true,
                field: 'dateTime',
                type: 'desc',
            }"
            ref="grid"
        ></data-grid>

        <v-dialog v-model="imageViewDialog" max-width="800">
            <v-card>
                <div v-for="image in clickedRow.images">
                    <v-img :src="image"></v-img>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "SMS",
        imageViewDialog: false,
        clickedRow: "",

        columns: [
            {
                field: "status",
                isIcon: true,
                icon: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                            return "mdi-message-alert";
                        case "NEW":
                            return "mdi-message-plus";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        case "DELIVERED":
                            return "mdi-message-text";
                        case "UNDELIVERED":
                            return "mdi-close-circle";
                        case "UNKNOWN":
                            return "mdi-message-question";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                        case "UNDELIVERED":
                            return "#f35123";
                        case "NEW":
                            return "info";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "#fdb400";
                        case "DELIVERED":
                            return "success";
                        case "SENT":
                        case "UNKNOWN":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "dateTime",
                type: "date",
                width: "150px",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    startDate: moment()
                        .subtract(1, "week")
                        .add(1, "day")
                        .format(),
                },
            },
            {
                sortable: true,
                label: "Name",
                field: "name",
                width: "250px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                width: "250px",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountId",
                width: "115px",
                link: (row) => {
                    return row.accountsSource == "DINNER"
                        ? "DinnerAccountView"
                        : "Account View";
                },
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Direction",
                field: "direction",
                isDropdown: true,
                width: "100px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [],
                },
            },
            {
                sortable: true,
                label: "From",
                field: "from",
                width: "150px",
                formatFn: (value) => {
                    return value.replace(
                        /(\d{1})(\d{3})(\d{3})(\d{4})/,
                        "$1 ($2) $3-$4"
                    );
                },
                searchValue: (value) => {
                    return value.replace(/[-() ]/g, "");
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "To",
                field: "to",
                width: "150px",
                formatFn: (value) => {
                    return value.replace(
                        /(\d{1})(\d{3})(\d{3})(\d{4})/,
                        "$1 ($2) $3-$4"
                    );
                },
                searchValue: (value) => {
                    return value.replace(/[-() ]/g, "");
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Text",
                field: "text",
                width: "400px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Attachment",
                field: "attachment",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
                showLink: (row) => {
                    return row.attachmentUrls;
                },
            },
            {
                sortable: true,
                label: "Status",
                field: "status",
                width: "200px",
                isDropdown: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [],
                },
            },
            {
                sortable: true,
                label: "Message Type",
                field: "messageType",
                width: "200px",
                hidden: true,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: ["SMS", "MMS"],
                },
            },
            {
                sortable: true,
                label: "Error Code",
                field: "errorCode",
                width: "150px",
                isDropdown: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterDropdownItems: [],
                },
            },
            {
                sortable: true,
                label: "User",
                field: "username",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                width: "200px",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        actions: [
            {
                text: "Send Message",
                link: "SendMessage",
            },
        ],
    }),
    watch: {},
    created() {
        this.columns.find((c) => c.field == "attachment").linkAction = (
            message
        ) => {
            const clickedRow = message;

            clickedRow.images = clickedRow.attachmentUrls.split(";");

            this.clickedRow = clickedRow;

            this.imageViewDialog = true;
        };
    },
    methods: {
        mapResults(results) {
            return results.map((sms) => {
                sms.attachment = sms.attachmentUrls ? "Attachment" : "";

                return sms;
            });
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}

.border-line {
    border: black 1px solid;
}

.scroll {
    overflow-y: auto;
}
</style>
